import { QRCodeSVG } from "qrcode.react";
import React, { useEffect, useMemo, useState, useRef, useCallback } from "react";
import { convertIntegerToMoney } from "../../modules/helpers";

import "../styles/components/pixticket.scss";
import { R$ } from "../utils/brl";
import Button from "./layout/button";
import Icon from "./layout/icon";
import ResultCard from "./layout/resultCard";

import {
  verificaPagamentoPix
} from "src/reducers/carrinho/carrinhoActions";
import { setApostaPendente } from "../../utils/getApostaPendente";

import { generateImage, shareImage } from "../../newDesign/utils/generateImage";
import { getNumberLength } from "../utils/getNumberLength";
import { emitIntent } from "../../newDesign/utils/emitIntent";
import { hasBitLogin } from "../../utils/getPreTickets";

/**
 *
 * @param {{
 * ticket:{
 *  bilhetes: {
 *    bets: {
 *      number: string,
 *      amount: number
 *  },
 *  value: number,
 *  date: string,
 *  extraction: string,
 *  concurso: string,
 *  info: {
 *      number: number,
 *      serial: string
 *  },
 *  prize: string,
 * }
 *
 * name: string
 * image: string
 * isLoteria: boolean
 * isRifa: boolean
 * isBicho: boolean
 * sabed: boolean
 * }[]
 *  onClose: () => void
 
 * }} props
 */
export default function PixTicket({ ticket, onClose, GoToPreTicket, toggleErrorModal, payload = undefined, isRifa = false, isBicho, saved = false }) {
  // Definir o tempo limite para 5 minutos e 20 segundos (320 segundos)
  const divRef = useRef(null);
  const extraTime = 20;
  const timeLimit = 300 + extraTime;

  const [activeBilheteIndex, setActiveBilheteIndex] = useState(0);

  const [pixTicket, setPixTicket] = useState(ticket);

  const [timeElapsed, setTimeElapsed] = useState(0);
  const [isPaidOut, setIsPaidOut] = useState(pixTicket.isError);
  const [isPaidOutError, setIsPaidOutError] = useState(pixTicket.isError);
  const [pixErrorMessage, setPixErrorMessage] = useState("");
  const [timestamp] = useState(ticket.timestamp || Date.now());
  const isExtraTimeRef = useRef(false);
  
  const [qrcodeLoader, setQrcodeLoader] = useState(false);

  const isTimeout = timeElapsed >= timeLimit;

  const objTipoJogo = ticket.objTipoJogo || {};


  useEffect(() => {
    isExtraTimeRef.current = timeElapsed >= timeLimit - extraTime;
  }, [timeElapsed]);

  useEffect(() => {
    emitIntent("scroll_window", { top: 60 });
  }, []);

  useEffect(() => {
    if (isPaidOut && !isPaidOutError) {
      setTimeout(() => {
        !hasBitLogin() && generateImage(divRef, toggleErrorModal, pixTicket.vchETicket);
      }, 1000);
    }
  }, [isPaidOut]);

  // Função para atualizar o tempo decorrido a cada 5 segundos
  const updateElapsedTime = () => {
    if (isTimeout) return;

    const delta = Date.now() - timestamp;
    setTimeElapsed(Math.floor(delta / 1000));
  };

  const updatePixStatus = () => {
    if (isTimeout) return;

    if (pixTicket && !pixTicket.qrCode) {
      setIsPaidOutError(true);
      setIsPaidOut(true);
      return;
    }

    verificaPagamentoPix(pixTicket, (res) => {
      if(isExtraTimeRef.current) setQrcodeLoader(false);
      else setQrcodeLoader(true); 

      if (res.tnyStatusPagamento === 1 && res.tnyStatusPreValidacao == 2) {
        // Grava aposta pix na memoria
        const newTicket = { ...pixTicket, ...res, detail: res.detail };

        for (const bilhete of (newTicket.bilhetes || [])) {
          if (!bilhete.bets || !bilhete.bets.length) {
            bilhete.bets = newTicket.bets;
          }
        }

        setPixTicket(newTicket);
        setPixErrorMessage("");

        setIsPaidOut(true);
        setIsPaidOutError(false);
      }

      if (res.isError || res.tnyStatusPagamento >= 2 || res.tnyStatusPreValidacao >= 3) {
        setIsPaidOutError(true);
        setIsPaidOut(true);
        setPixErrorMessage("Entre em contato com o suporte.");
        toggleErrorModal('Atenção', res.strErrorMessage);
      }
    }, payload);
  }

  useEffect(() => {
    // Criar o intervalo a cada 5 segundos

    const clock = setInterval(updateElapsedTime, 1000);
    const interval = setInterval(updatePixStatus, 3000);

    const clear = () => {
      clearInterval(clock);
      clearInterval(interval);
    }

    if (isTimeout || isPaidOut || isPaidOutError) {
      clear();
    } else {
      updateElapsedTime();
    }

    // Limpar o intervalo quando o componente é desmontado
    return () => {
      clear();
    }
  }, [isTimeout, isPaidOut, isPaidOutError]);

  useEffect(() => {
    // Encerrar o intervalo após 5 minutos e 15 segundos
    if (timeElapsed >= timeLimit || isPaidOut) {
      if (!isPaidOut) setIsPaidOutError(true);
      setIsPaidOut(true);
    }
  }, [timeElapsed]);

  useEffect(() => {
    if (GoToPreTicket) GoToPreTicket();
    if (!saved) setApostaPendente({ ...pixTicket, detail: {} });
  }, []);

  // Função para formatar o tempo decorrido no formato MM:SS
  const formatTime = (timeElapsed) => {
    const timer = ((timeLimit - extraTime) - timeElapsed);
    const remainingTime = timer > 0 ? timer : 0;
    const minutes = Math.floor(remainingTime / 60);
    const seconds = remainingTime % 60;
    return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
  };

  /**
   *
   * @param {string} title
   * @param {string} data
   * @param {string} subtitle
   * @returns
   */

  const copyText = (text) => {
    navigator.clipboard.writeText(text).catch(() => {
      emitIntent("copy_text", { text });
    });

    toggleErrorModal("Código copiado", "Código PIX copiado com sucesso!", true);
  }

  const row = (title, data, subtitle, valueClassName = "") => {
    if (!data) {
      return <React.Fragment></React.Fragment>;
    }

    return (
      <React.Fragment>
        <p>
          <strong>{title}: </strong>
          <span className={valueClassName}>{data}</span>
          {subtitle ? (
            <React.Fragment>
              <br />
              <small>{subtitle}</small>
            </React.Fragment>
          ) : null}
        </p>
      </React.Fragment>
    );
  };

  const renderQrCode = () => {
    let soma = 0;
    for (let i = 0; i < pixTicket.bilhetes.length; i++) {
      soma += pixTicket.bilhetes[i].value;
    }
    return (
      <React.Fragment>
        {qrcodeLoader ?
          <React.Fragment>
            <div className="pixticket-qrcode-header">
              <h4>{`Valor Total: ${R$(soma)}`}</h4>
              <h4>Seu código Pix</h4>
            </div>
            <div className="pixticket-qrcode-body">
              <Button
                color="main"
                onClick={() => { copyText(pixTicket.qrCode) }}
              >
                <Icon type="chevronRight" color="white" />
                Pix Copia e Cola
              </Button>
              <QRCodeSVG value={pixTicket.qrCode} />
              <h5 style={{ margin: 0 }}>Seu código pix expira em:</h5>
              <div className="pixticket-timer">
                <h3 style={{ margin: 0 }}>00:{formatTime(timeElapsed)}</h3>
              </div>
            </div>
            <div className="pixticket-qrcode-footer">
              <p style={{ lineBreak: 'anywhere' }}>{pixTicket.qrCode}</p>
            </div>
          </React.Fragment>
          :
          <React.Fragment>
            <div className="pixticket-qrcode-header">
              { isExtraTimeRef.current ? <h4>Carregando QrCode...</h4> : null }
            </div>
            <div className="pixticket-qrcode-body">
              <div className="loader" style={{ margin: "2vh" }}></div>
            </div>
          </React.Fragment>
        }
      </React.Fragment>
    )
  }

  /**
   * @param {"paid"|"not paid"|"no qrcode"} type 
   * @param {boolean} hideButtons 
   * @param {number} ticketNumber 
   * @returns 
   */
  const renderQrCodePaidOut = (type = false, hideButtons = false, ticketNumber = null) => {
    return (
      <React.Fragment>
        {type === "paid" ?
          <React.Fragment>
            <div className="pixticket-paidout-header">
              <Icon type="doneCircle" color="white" key="a" />
              <h2>Pagamento Confirmado</h2>
              <h4>Confira suas apostas em “Meus Tickets”</h4>
            </div>
            <div className="pixticket-paidout-footer">

              {(!hideButtons && !hasBitLogin()) ?
                <React.Fragment>
                  <Button
                    className="rifa-button"
                    color="main"
                    onClick={(e) => { emitIntent("reload"); onClose(e); }}
                  >
                    <Icon type="close" color="white" style={{ marginRight: 5 }} />
                    Fechar
                  </Button>
                  <Button
                    className="rifa-button"
                    color="main"
                    onClick={() => { generateImage(divRef, toggleErrorModal, ticketNumber) }}
                  >
                    <Icon type="download" color="white" style={{ marginRight: 5 }} />
                    Baixar Comprovante
                  </Button>
                </React.Fragment>
              : null}
            </div>
          </React.Fragment>
        :
          <React.Fragment>
            {type === "not paid" ? 
              <div className="pixticket-paidout-header">
                {/* <Icon type="undoneCircle" color="white" key="b" /> */}
                <h2 style={{color: "var(--main)"}}>Pagamento não identificado</h2>
                pixErrorMessage ? 
                  <h4>{pixErrorMessage}</h4> 
                  : 
                  <h4>
                    Não identificamos seu pagamento. 
                    Verifique em <strong>Meus Tickets</strong>, e caso não encontre o seu bilhete entre em contato com a central de atendimento.
                  </h4>
              </div>
              : <div className="pixticket-paidout-header">
                {/* <Icon type="undoneCircle" color="white" key="b" /> */}
                <h2 style={{color: "var(--main)"}}>Erro ao gerar QRCode PIX</h2>
                <h4>
                  Houve um erro inesperado no sistema, e o QRCode de pagamento PIX não pôde ser gerado.
                </h4>
                <h4>
                  Tente novamente e, caso o erro persista, por favor entre em contato com o suporte.
                </h4>
              </div>
            }
            <div className="pixticket-paidout-footer">
              <Button
                className="rifa-button"
                color="main"
                onClick={(e) => { emitIntent("reload"); onClose(e); }}
              >
                <Icon type="close" color="white" style={{ marginRight: 5 }} />
                Fechar
              </Button>
            </div>
          </React.Fragment>
        }
      </React.Fragment>
    )
  }

  const renderTicket = (hideButtons = false) => {
    const styleForHideTicket = {
      zIndex: -1,
      top: `-3000px`
    }

    const numberLength = getNumberLength(objTipoJogo, isBicho);

    return (
      <React.Fragment>
        <div className="rifa-ticket" style={hideButtons ? styleForHideTicket : {}}>
          <div
            className="rifa-ticket__all_background"
            style={{
              transform: `translateX(${0 - 100 * activeBilheteIndex}vw)`,
            }}
          >
            {pixTicket.bilhetes &&
              pixTicket.bilhetes.map(
                (
                  {
                    bets,
                    value,
                    date,
                    prize,
                    extraction,
                    concurso,
                    venda,
                    name,
                    image,
                    isLoteria = true,
                    arrJogo,
                    intNumeroPule,
                    vchCodigoSeguranca,
                    chrSerial,
                    leagues,
                    teams,
                  },
                  index
                ) => {
                  const teamValue = useMemo(() => {
                    if (!teams) {
                      return 0;
                    }

                    return convertIntegerToMoney(
                      teams.reduce((sum, item) => sum + item.valor, 0)
                    );
                  }, [teams]);

                  const leagueValue = useMemo(() => {
                    if (!leagues) {
                      return 0;
                    }

                    return convertIntegerToMoney(
                      leagues.reduce((sum, item) => sum + item.valor, 0)
                    );
                  }, [leagues]);

                  const betsLength = useMemo(() => {
                    if (arrJogo) {
                      return arrJogo.length;
                    }

                    if (bets) {
                      let totalAmount = 0;
                      for (let i = 0; i < bets.length; i++) {
                        totalAmount += bets[i].amount;
                      }
                      return totalAmount;
                    }

                    if (teams || leagues) {
                      return (leagues || []).concat(teams || []).length;
                    }

                    return undefined;
                  }, [arrJogo, bets, teams, leagues]);

                  const newBetCart = useMemo(() => {
                    if (pixTicket.detail.arrApostas) {
                      const transformedArray = [];
                      pixTicket.detail.arrApostas.forEach(item => {
                        const existingItem = transformedArray.find(obj => obj.number === item.vchNumero);
                        const jogoCorrespondente = (pixTicket.arrJogo && pixTicket.arrJogo.find((jogo) => jogo.vchNumero === item.vchNumero));

                        if (existingItem) {
                          existingItem.amount += 1;
                        } else {
                          transformedArray.push({
                            number: item.vchNumero,
                            value: item.numValor,
                            amount: 1,
                            jogo: jogoCorrespondente
                          });
                        }
                      });
                      return transformedArray;
                    }

                    return (bets || []).map((bet) => {
                      const jogoCorrespondente = (pixTicket.arrJogo && pixTicket.arrJogo.find((jogo) => jogo.vchNumero === bet.number));
                      return {...bet, jogo: jogoCorrespondente}
                    });
                  }, [bets]);

                  return (
                    <div className="rifa-ticket__background">
                      <div style={{ position: "absolute", height: "100vh", width: "100vw", }}
                        onClick={onClose}></div>
                      <div className="rifa-ticket__container" ref={divRef}>
                        <div className="rifa-ticket__cropped_top"></div>
                        <div className="rifa-ticket__header">
                        </div>
                        { isPaidOutError ? null : <div className="rifa-ticket__content" key={name + index}>
                          <p className="rifa-ticket__title rifa-title">
                            {name
                              || (isPaidOut && !isPaidOutError ? (
                                "Comprovante de Aposta"
                              ) : (
                                "Pagamento de Aposta"
                              ))}
                          </p>
                          {
                            !!image && <img src={image} className="rifa-ticket__image" />
                          }
                          <div className="rifa-ticket__details">
                            {row("Aposta realizada em", date)}
                            {row("Venda", venda || pixTicket.vchETicket)}
                            {row("Bilhete", intNumeroPule || pixTicket.intNumeroPule + index)}
                            {row("Código de Segurança", vchCodigoSeguranca || pixTicket.vchCodigoSeguranca)}
                            {row("Serial", chrSerial || pixTicket.chrSerial)}
                            {isRifa ?
                              row("Data do sorteio", (extraction && extraction.includes("2079")) ? null : extraction)
                              : isLoteria ?
                                row("Extração", extraction)
                                : row("Concurso", concurso)
                            }
                            <hr className="divider"></hr>
                            {row("Valor apostado", R$(value))}
                            <p className="rifa-ticket__bets-header rifa-subtitle"></p>
                            {row("Quantidade de apostas", betsLength)}
                            {(pixTicket.numPremioTotal || pixTicket.numValorPremioCotaTotal) ? row("Valor premiado", convertIntegerToMoney(Math.max(pixTicket.numPremioTotal, pixTicket.numValorPremioCotaTotal) * 100), null, "earnedPrizeValue") : null}
                            {(arrJogo && arrJogo.length) ?
                              arrJogo.map((jogo, index) => {
                                return (
                                <ResultCard
                                  isBallType={!isLoteria}
                                  index={index + 1}
                                  title={jogo.nome}
                                  key={jogo.nome}
                                  valorTotal={convertIntegerToMoney(jogo.valorTotal || jogo.valor)}
                                  numbers={jogo.arrNumeros}
                                  premio={jogo.premio}
                                  numberLength={numberLength}
                                  tipoJogo={jogo.tipoJogo}
                                  isBicho={isBicho}
                                  earned={(jogo.numPremio && jogo.numPremio > 0) || (jogo.numPremio && jogo.numValorPremioCota > 0)}
                                  earnedFromQuota={jogo.numValorPremioCota && jogo.numValorPremioCota > 0}
                                />
                              )})
                            : bets && bets.length > 0 && (
                              <ResultCard
                                isBallType={!isLoteria}
                                cart={newBetCart}
                                index={arrJogo ? arrJogo.length + 1 : 1}
                                title={name}
                                numberLength={numberLength}
                                isBicho={isBicho}
                              />
                            )}
                            {leagues && leagues.length > 0 && (
                              <ResultCard
                                title={`${name} - Ligas`}
                                valorTotal={leagueValue}
                                index={1}
                                teams={leagues}
                                numberLength={numberLength}
                              />
                            )}
                            {teams && teams.length > 0 && (
                              <ResultCard
                                title={`${name} - Times`}
                                valorTotal={teamValue}
                                index={leagues && leagues.length > 0 ? 2 : 1}
                                teams={teams}
                                numberLength={numberLength}
                              />
                            )}
                          </div>
                          {pixTicket.bilhetes && pixTicket.bilhetes.length > 1 && (
                            <div className="ticket-pagination">
                              <Button
                                className="rifa-button"
                                color="main"
                                onClick={() =>
                                  setActiveBilheteIndex((state) => state - 1)
                                }
                                disabled={activeBilheteIndex === 0}
                                style={{ transform: "rotate(180deg)" }}
                              >
                                <Icon type="chevronRight" color="white" />
                              </Button>

                              <div className="pagination-dots">
                                {pixTicket.bilhetes.map((Bilhete, index) => (
                                  <div
                                    className={`dot ${index === activeBilheteIndex ? "active" : ""
                                      }`}
                                    onClick={() => setActiveBilheteIndex(index)}
                                    key={index}
                                  />
                                ))}
                              </div>
                              <Button
                                className="rifa-button"
                                color="main"
                                onClick={() =>
                                  setActiveBilheteIndex((state) => state + 1)
                                }
                                disabled={
                                  activeBilheteIndex >= pixTicket.bilhetes.length - 1
                                }
                              >
                                <Icon type="chevronRight" color="white" />
                              </Button>
                            </div>
                          )}
                        </div>
                        }

                        <div className="pixticket-qrcode">
                          {
                            isPaidOut ?
                              renderQrCodePaidOut(pixTicket.qrCode ? (isPaidOutError ? "not paid" : "paid") : "no qrcode", hideButtons, pixTicket.vchETicket)
                              :
                              renderQrCode()
                          }
                        </div>

                        <div className="rifa-ticket__cropped_bottom"></div>
                      </div>
                    </div>
                  );
                }
              )}
          </div>
        </div>
      </React.Fragment>
    )
  }

  return (
    <React.Fragment>
      {renderTicket(false)}
      {renderTicket(true)}
    </React.Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/rifa/components/pixticket.jsx